import { mutualTheme } from '~/utils/theme'
import { useMediaQuery } from '@material-ui/core'

export const useIsSmallScreen = () => {
  return useMediaQuery(mutualTheme.breakpoints.down('sm'))
}

export const useIsMobileScreen = () => {
  return useMediaQuery(mutualTheme.breakpoints.down('md'))
}

export const useIsTabletScreen = () => {
  return useMediaQuery(mutualTheme.breakpoints.down('lg'))
}
